/* Growth Automated theme — shared behaviour (self-contained, no dependencies) */
(function () {
  /* ---- Mobile nav drawer ---- */
  var mnav = document.getElementById('mnav');
  var btn = document.getElementById('menuBtn');
  if (mnav && btn) {
    var open = function () {
      mnav.classList.add('open');
      document.body.classList.add('mnav-open');
      mnav.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
    };
    var close = function () {
      mnav.classList.remove('open');
      document.body.classList.remove('mnav-open');
      mnav.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-expanded', 'false');
    };
    btn.addEventListener('click', open);
    mnav.querySelectorAll('[data-mnav-close]').forEach(function (el) { el.addEventListener('click', close); });
    mnav.querySelectorAll('.mnav-links a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- Carousel dot indicators (mobile) ---- */
  function buildDots(track) {
    var cards = [].slice.call(track.children);
    if (cards.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'cdots';
    cards.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to item ' + (i + 1));
      b.addEventListener('click', function () {
        var left = track.scrollLeft + (c.getBoundingClientRect().left - track.getBoundingClientRect().left) - 24;
        track.scrollTo({ left: left, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });
    track.parentNode.insertBefore(dots, track.nextSibling);
    function update() {
      var tl = track.getBoundingClientRect().left, best = 0, bestD = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - tl - 24);
        if (d < bestD) { bestD = d; best = i; }
      });
      [].forEach.call(dots.children, function (d, i) { d.classList.toggle('active', i === best); });
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    update();
  }
  document.querySelectorAll('[data-carousel]').forEach(buildDots);
})();
